import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  changePasswordOTP: [],
  isLoading: false,
  error: "",
  hasData: false,
  codeStatus: "pending",
  changePasswordStatus: {
    status: false,
    message: ""
  }
};
const crmChangePasswordOTPSlice = createSlice({
  name: "changePasswordotpSection",
  initialState,
  reducers: {
    sendCrmChangePasswordOTPPending: state => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    sendCrmChangePasswordOTPSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.changePasswordOTP = action.payload;
      state.codeStatus = "success";
      state.changePasswordStatus.message = "UPDATE has been successfully completed.";
      state.changePasswordStatus.status = true;
      localStorage.setItem("isCRMLoggedIn", JSON.stringify(true));
    },
    sendCrmChangePasswordOTPFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.codeStatus = "failure";
    },
    resetCrmChangePasswordOTPData: state => {
      state.codeStatus = "pending";
      state.error = "";
      state.changePasswordOTP = [];
      state.hasData = false;
      state.changePasswordStatus.message = "";
      state.changePasswordStatus.status = false;
    }
  }
});
export const {
  sendCrmChangePasswordOTPPending,
  sendCrmChangePasswordOTPSuccess,
  sendCrmChangePasswordOTPFailure,
  resetCrmChangePasswordOTPData
} = crmChangePasswordOTPSlice.actions;
export default crmChangePasswordOTPSlice.reducer;